"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ContactBox = exports.EmptyStateBox = exports.Mask = exports.HomeListItemMask = exports.HomeListItemImg = exports.HomeListItemBox = exports.SliderItemBox = exports.ArrowBox = exports.SliderBox = exports.Image = exports.AdamsBody = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _StyledLayout = require("../../../StyledLayout");

var _constants = require("../../constants/constants");

/* eslint-disable max-len */
var themeTopNavHeight = _constants.adamsDimensions.themeTopNavHeight,
    desktopFooterOffset = _constants.adamsDimensions.desktopFooterOffset,
    mobileFooterOffset = _constants.adamsDimensions.mobileFooterOffset,
    typeThemeModalTitleHeight = _constants.adamsDimensions.typeThemeModalTitleHeight;

var AdamsBody = _styledComponents["default"].div.withConfig({
  displayName: "Elements__AdamsBody",
  componentId: "sc-75l3nn-0"
})(["position:relative;height:", " overflow-y:", ";background:", ";", " &::-webkit-scrollbar{display:none;}"], function (props) {
  var offset = props.isTabletPortrait ? desktopFooterOffset : mobileFooterOffset;
  var extraOffset = props.isTypeTheme ? " - ".concat(typeThemeModalTitleHeight) : '';

  if (props.vh1) {
    // When vh1 * 100 happens, it drops a decimal place. We add + 1px to make up for the rounding error
    return "calc(".concat(props.vh1 * 100, "px - ").concat(themeTopNavHeight, " - ").concat(offset).concat(extraOffset, " + 1px);");
  }

  return "calc(100vh - ".concat(themeTopNavHeight, " - ").concat(offset).concat(extraOffset, ");");
}, function (props) {
  return props.canScroll ? 'scroll' : 'hidden';
}, function (props) {
  return props.theme.portfolioBackground1;
}, function (props) {
  return props.isTabletPortrait && "\n    padding-bottom: 40px;\n  ";
});

exports.AdamsBody = AdamsBody;

var Image = _styledComponents["default"].img.withConfig({
  displayName: "Elements__Image",
  componentId: "sc-75l3nn-1"
})(["width:100%;object-fit:cover;height:100%;"]);

exports.Image = Image;

var SliderBox = _styledComponents["default"].div.withConfig({
  displayName: "Elements__SliderBox",
  componentId: "sc-75l3nn-2"
})(["position:relative;.slick-prev{left:0;z-index:2;&:before{font-size:unset;}}.slick-next{right:48px;&:before{font-size:unset;}}"]);

exports.SliderBox = SliderBox;
var ArrowBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__ArrowBox",
  componentId: "sc-75l3nn-3"
})(["width:48px !important;height:48px !important;border-radius:50% !important;background:rgba(255,255,255,0.5) !important;display:flex !important;align-items:center !important;justify-content:center !important;"]);
exports.ArrowBox = ArrowBox;
var SliderItemBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__SliderItemBox",
  componentId: "sc-75l3nn-4"
})(["height:", " position:relative;cursor:pointer;img{transition:all 0.5s;}&:hover{img{transform:scale(1.1);}}"], function (props) {
  var offset = props.isTabletPortrait ? desktopFooterOffset : mobileFooterOffset;
  var extraOffset = props.isTypeTheme ? " - ".concat(typeThemeModalTitleHeight) : '';

  if (props.vh1) {
    // When vh1 * 100 happens, it drops a decimal place. We add + 1px to make up for the rounding error
    return "calc(".concat(props.vh1 * 100, "px - ").concat(themeTopNavHeight, " - ").concat(offset).concat(extraOffset, " + 1px)};");
  }

  return "calc(100vh - ".concat(themeTopNavHeight, " - ").concat(offset).concat(extraOffset, ")};");
});
exports.SliderItemBox = SliderItemBox;
var HomeListItemBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__HomeListItemBox",
  componentId: "sc-75l3nn-5"
})(["position:relative;height:240px;width:100%;"]);
exports.HomeListItemBox = HomeListItemBox;

var HomeListItemImg = _styledComponents["default"].img.withConfig({
  displayName: "Elements__HomeListItemImg",
  componentId: "sc-75l3nn-6"
})(["height:100%;width:100%;object-fit:cover;"]);

exports.HomeListItemImg = HomeListItemImg;

var HomeListItemMask = _styledComponents["default"].div.withConfig({
  displayName: "Elements__HomeListItemMask",
  componentId: "sc-75l3nn-7"
})(["position:absolute;height:100%;width:100%;top:0;left:0;background:linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3));z-index:2;color:", ";display:flex;flex-direction:column;align-items:center;justify-content:center;font-family:", ";font-style:normal;font-weight:normal;"], function (props) {
  return props.theme.white;
}, function (props) {
  return props.theme.portfolioFontFamily || props.theme.fontFamilyDefault;
});

exports.HomeListItemMask = HomeListItemMask;

var Mask = _styledComponents["default"].div.withConfig({
  displayName: "Elements__Mask",
  componentId: "sc-75l3nn-8"
})(["position:absolute;height:", " width:100%;top:0;left:0;background:linear-gradient(0deg,rgba(0,0,0,0.3),rgba(0,0,0,0.3));z-index:2;color:", ";display:flex;align-items:center;justify-content:center;flex-direction:column;font-family:", ";font-style:normal;font-weight:normal;"], function (props) {
  var offset = props.isTabletPortrait ? desktopFooterOffset : mobileFooterOffset;
  var extraOffset = props.isTypeTheme ? " - ".concat(typeThemeModalTitleHeight) : '';

  if (props.vh1) {
    // When vh1 * 100 happens, it drops a decimal place. We add + 1px to make up for the rounding error
    return "calc(".concat(props.vh1 * 100, "px - ").concat(themeTopNavHeight, " - ").concat(offset).concat(extraOffset, " + 1px)};");
  }

  return "calc(100vh - ".concat(themeTopNavHeight, " - ").concat(offset).concat(extraOffset, ")};");
}, function (props) {
  return props.theme.white;
}, function (props) {
  return props.theme.portfolioFontFamily || props.theme.fontFamilyDefault;
});

exports.Mask = Mask;
var EmptyStateBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__EmptyStateBox",
  componentId: "sc-75l3nn-9"
})(["height:100%;width:100%;"]);
exports.EmptyStateBox = EmptyStateBox;
var ContactBox = (0, _styledComponents["default"])(_StyledLayout.Box).withConfig({
  displayName: "Elements__ContactBox",
  componentId: "sc-75l3nn-10"
})(["box-sizing:border-box;padding:32px 0;"]);
exports.ContactBox = ContactBox;